import React, { useContext } from 'react'
import { StyledFooterRow, FooterCell, StyledFooter } from './StyledDataTable'
import { DataTableContext } from './DataTable'

const TableFooter = () => {
	const { headerGroups, rows, additionalWidth } = useContext(DataTableContext)

	const getValuesForAggregation = column => rows.reduce((acc, { values, isExpanded, isAggregated, subRows }) => {
		if(!isExpanded) {
			/*if(isAggregated) {
				// Return values from subRows in aggregated rows because aggregated value can be in NaN format
				const subRowsVals = subRows.map(({ values: subRowValues }) => subRowValues[column.id])
				return [...acc, ...subRowsVals]
			}*/
			acc.push(column.accessor(values))
		}
		return acc
	}, [])


	const renderFooterCell = (column, i) => {
		const hasValue = !!column.aggregate
		return(
			<FooterCell
				noSeparator={!hasValue}
				{...column.getHeaderProps()}
				key={i}
				style={{ ...column.footerStyle, minWidth: `${(column.width) + additionalWidth}px` }}
			>
				{hasValue ? column.aggregate(getValuesForAggregation(column), { isFooter: true, toLocale: true }) || '' : ''}
			</FooterCell>
		)
	}

	return(
		<StyledFooter>
			{headerGroups.map((headerGroup, i) => (
				<StyledFooterRow key={i}>
					{headerGroup.headers.map(renderFooterCell)}
				</StyledFooterRow>
			))}
		</StyledFooter>
	)
}

export default TableFooter
